import { CSSProperties, useEffect, useRef } from 'react';
import LOADING_GRADIENT_SHADOW from './assets/gradient_shadow.png';
import LOADING_GRADIENT_NO_SHADOW from './assets/gradient_no_shadow.png';
import LOADING_BALL from './assets/loading_ball.json';
import cls from 'classnames';
import lottie from 'lottie-web/build/player/lottie_light_canvas';

import './style.scss';

export interface LoadingProps {
  variant: 'ball' | 'gradient';

  /**
   * @default false
   */
  shadow?: boolean;

  /**
   * @default false
   */
  fitParent?: boolean;

  style?: CSSProperties;
}

export const LoadingBall = (props: { fitParent: boolean; style: CSSProperties }): JSX.Element => {
  const { fitParent, style = {} } = props;
  const loadingDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (loadingDiv.current) {
      lottie.loadAnimation({
        container: loadingDiv.current,
        renderer: 'canvas',
        loop: true,
        autoplay: true,
        animationData: LOADING_BALL,
      });
    }
  }, []);

  return (
    <div
      className={cls('design-system-loading-ball', {
        'fit-parent': fitParent,
      })}
      style={style}
    >
      <div ref={loadingDiv} className="design-system-loading-ball-lottie" />
    </div>
  );
};

export const LoadingGradient = (props: { shadow: boolean; fitParent: boolean; style: CSSProperties }): JSX.Element => {
  const { shadow, fitParent, style = {} } = props;
  return (
    <div
      className={cls('design-system-loading-gradient', {
        'fit-parent': fitParent,
      })}
      style={style}
    >
      <div
        className="design-system-loading-gradient-circle"
        style={{
          backgroundImage: `url(${shadow ? LOADING_GRADIENT_SHADOW : LOADING_GRADIENT_NO_SHADOW})`,
        }}
      />
    </div>
  );
};

export const Loading = (props: LoadingProps): JSX.Element => {
  const { variant, shadow = false, fitParent = false, style = {} } = props;

  return (
    <>
      {variant === 'ball' && <LoadingBall fitParent={fitParent} style={style} />}
      {variant === 'gradient' && <LoadingGradient shadow={shadow} fitParent={fitParent} style={style} />}
    </>
  );
};
